'use client';

import React from 'react';

/**
 * Renders nothing if the cancellation-policy UI throws, so a bad policy payload can never break the
 * surrounding reservation flow.
 */
export class CancellationPolicyErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
